import { Form, InputNumber } from 'antd'
import { FC, useContext } from 'react'
import { EditableCellCtx } from '../../../../../../components/editable-cell/editable-cell'

interface PaintCostOf1000DurstWgProps {}

const PaintCostOf1000DurstWg: FC<PaintCostOf1000DurstWgProps> = () => {
    const ctx = useContext(EditableCellCtx)

    return (
        <Form.Item name={'paintCostOf1000DurstWG'} noStyle>
            <InputNumber autoFocus onBlur={ctx.onBlur} controls={false} />
        </Form.Item>
    )
}

export default PaintCostOf1000DurstWg
